/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One admission as read from MatrixCare.
 * @export
 * @interface MatrixCareLiveAdmission
 */
export interface MatrixCareLiveAdmission {
    /**
     * MatrixCare `AdmissionId`.
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    admission_id: string;
    /**
     * MatrixCare's numeric admission key.
     * @type {number}
     * @memberof MatrixCareLiveAdmission
     */
    admission_key?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    referral_id?: string | null;
    /**
     * e.g. "New Referral", "Discharge Pending", "Admitted".
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    status?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixCareLiveAdmission
     */
    status_code?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    status_id?: string | null;
    /**
     * ISO YYYY-MM-DD.
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    effective_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    business_unit_id?: string | null;
    /**
     * Resolved from the business unit lookup.
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    business_unit_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    line_of_business_id?: string | null;
    /**
     * e.g. "Skilled OASIS", "Skilled Non OASIS".
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    line_of_business_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    line_of_business_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareLiveAdmission
     */
    certification_period_start?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCareLiveAdmission
     */
    is_new_referral: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCareLiveAdmission
     */
    is_hospice_patient: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCareLiveAdmission
     */
    is_resumed: boolean;
}

/**
 * Check if a given object implements the MatrixCareLiveAdmission interface.
 */
export function instanceOfMatrixCareLiveAdmission(value: object): value is MatrixCareLiveAdmission {
    if (!('admission_id' in value) || value['admission_id'] === undefined) return false;
    if (!('is_new_referral' in value) || value['is_new_referral'] === undefined) return false;
    if (!('is_hospice_patient' in value) || value['is_hospice_patient'] === undefined) return false;
    if (!('is_resumed' in value) || value['is_resumed'] === undefined) return false;
    return true;
}

export function MatrixCareLiveAdmissionFromJSON(json: any): MatrixCareLiveAdmission {
    return MatrixCareLiveAdmissionFromJSONTyped(json, false);
}

export function MatrixCareLiveAdmissionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareLiveAdmission {
    if (json == null) {
        return json;
    }
    return {
        
        'admission_id': json['admission_id'],
        'admission_key': json['admission_key'] == null ? undefined : json['admission_key'],
        'referral_id': json['referral_id'] == null ? undefined : json['referral_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'status_code': json['status_code'] == null ? undefined : json['status_code'],
        'status_id': json['status_id'] == null ? undefined : json['status_id'],
        'effective_date': json['effective_date'] == null ? undefined : json['effective_date'],
        'business_unit_id': json['business_unit_id'] == null ? undefined : json['business_unit_id'],
        'business_unit_name': json['business_unit_name'] == null ? undefined : json['business_unit_name'],
        'line_of_business_id': json['line_of_business_id'] == null ? undefined : json['line_of_business_id'],
        'line_of_business_name': json['line_of_business_name'] == null ? undefined : json['line_of_business_name'],
        'line_of_business_type': json['line_of_business_type'] == null ? undefined : json['line_of_business_type'],
        'certification_period_start': json['certification_period_start'] == null ? undefined : json['certification_period_start'],
        'is_new_referral': json['is_new_referral'],
        'is_hospice_patient': json['is_hospice_patient'],
        'is_resumed': json['is_resumed'],
    };
}

export function MatrixCareLiveAdmissionToJSON(json: any): MatrixCareLiveAdmission {
    return MatrixCareLiveAdmissionToJSONTyped(json, false);
}

export function MatrixCareLiveAdmissionToJSONTyped(value?: MatrixCareLiveAdmission | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'admission_id': value['admission_id'],
        'admission_key': value['admission_key'],
        'referral_id': value['referral_id'],
        'status': value['status'],
        'status_code': value['status_code'],
        'status_id': value['status_id'],
        'effective_date': value['effective_date'],
        'business_unit_id': value['business_unit_id'],
        'business_unit_name': value['business_unit_name'],
        'line_of_business_id': value['line_of_business_id'],
        'line_of_business_name': value['line_of_business_name'],
        'line_of_business_type': value['line_of_business_type'],
        'certification_period_start': value['certification_period_start'],
        'is_new_referral': value['is_new_referral'],
        'is_hospice_patient': value['is_hospice_patient'],
        'is_resumed': value['is_resumed'],
    };
}

